import { inject, Injectable } from '@angular/core'
import CONTRACT_STATE, { ContractState } from '../../../constants/contractState.constant'
import CONTRACT_STATE_LABEL from '../../../constants/contractStateLabel.constant'
import { Store } from '@ngrx/store'
import { ContractStateFilterActions } from '../../../domain/contract/components/contract-state-filter/state/action-types'
import { ExpirationDateFilterActions } from '../../../domain/contract/components/expiration-date-filter/state/action-types'
import { ContractValidityFilterActions } from '../../../domain/contract/components/contract-validity-filter/state/action-types'
import { CadastralAreaFilterActions } from '../../../domain/cadastral/components/cadastral-area-filter/state/action-types'
import { ContractSearchActions } from '../../../domain/contract/components/contract-search/state/action-types'
import { SubjectSearchActions } from '../../../domain/subject/components/subject-search/state/action-types'
import { ContractGroupSearchActions } from '../../../domain/contract/components/contract-group-search/state/action-types'

@Injectable({
    providedIn: 'root',
})
export class ContractsFilterHelpersService {
    private store: Store

    constructor() {
        this.store = inject(Store)
    }

    public getContractFilterActions(criteria, presetAble: boolean = true): any[] {
        const actions: any[] = [
            // --- contract search
            ContractSearchActions.updateFilterCriteria({ criteriaFragment: { searchText: criteria.contractNumberOfficial } }),
            ExpirationDateFilterActions.setExistencyDate({ existencyDate: criteria.existencyDate }),
            ExpirationDateFilterActions.setExistencyIntervalFrom({ existencyIntervalFrom: criteria.existencyIntervalFrom }),
            ExpirationDateFilterActions.setExistencyIntervalTo({ existencyIntervalTo: criteria.existencyIntervalTo }),
            ExpirationDateFilterActions.setEffectiveType({ effectiveType: criteria.effectiveType }),
            // --- subject search
            SubjectSearchActions.updateFilterCriteria({ criteriaFragment: { searchText: criteria.subjectSearchText } }),
            // @TODO: setSubjectId() was added by migration
            SubjectSearchActions.setSubjectId({ subjectId: criteria.subjectId }),
        ]

        if (Object.prototype.hasOwnProperty.call(criteria, 'selectedAreas') && Array.isArray(criteria.selectedAreas) && presetAble) {
            actions.push(CadastralAreaFilterActions.setSelectedAreas({ selectedAreas: criteria.selectedAreas }))
        }

        // --- contract group search
        actions.push(ContractGroupSearchActions.setSelectedContractGroup({
            selectedContractGroup: {
                id: criteria.contractGroupId,
                name: criteria.contractGroupName,
            },
        }))

        actions.push(ContractStateFilterActions.setState({
            filter: {
                revisionId: criteria.revisionId,
                selectedStates: criteria.selectedStates,
                existencyDate: criteria.existencyDate,
                existencyIntervalFrom: criteria.existencyIntervalFrom,
                existencyIntervalTo: criteria.existencyIntervalTo,
                substateFlag: criteria.substateFlag,
                selectedTypes: criteria.selectedTypes,
            },
        }))

        actions.push(ContractValidityFilterActions.setState({ items: criteria.validityState }))
        return actions
    }

    public getStateDefinition(state: ContractState): StateDefinition {
        const stateDefinition = {
            state: [state],
            sentForSignatureFlag: [],
            signingProcess: [],
        }

        switch (state) {
            case CONTRACT_STATE.valid:
                stateDefinition.sentForSignatureFlag = [false]
                break
            case CONTRACT_STATE.proposal:
                stateDefinition.signingProcess = [false]
                break
            case CONTRACT_STATE.valid_unsigned:
                stateDefinition.state = [ContractState.Valid]
                stateDefinition.sentForSignatureFlag = [true]
                break
            case CONTRACT_STATE.proposal_esign:
                stateDefinition.state = [ContractState.Proposal]
                stateDefinition.signingProcess = [true]
                break
        }

        return stateDefinition
    }

    public getContractStateMap(): ContractStateMap {
        return {
            [CONTRACT_STATE_LABEL.proposal]: CONTRACT_STATE.proposal,
            [CONTRACT_STATE_LABEL.valid]: CONTRACT_STATE.valid,
            [CONTRACT_STATE_LABEL.postponed]: CONTRACT_STATE.postponed,
            [CONTRACT_STATE_LABEL.finished]: CONTRACT_STATE.finished,
        }
    }

    public mergeStatesToCriteria(filterCriteria, states): void {
        let mergedStates = []
        let mergedSentForSignatureFlags = []
        let mergedSentEsignFlags = []

        states.forEach((state) => {
            let stateDef = this.getStateDefinition(state)
            mergedStates = mergedStates.concat(stateDef.state)
            mergedSentForSignatureFlags = mergedSentForSignatureFlags.concat(stateDef.sentForSignatureFlag)
            mergedSentEsignFlags = mergedSentEsignFlags.concat(stateDef.signingProcess)
        })

        filterCriteria.state = mergedStates
        filterCriteria.sentForSignatureFlag = mergedSentForSignatureFlags
        filterCriteria.signingProcess = mergedSentEsignFlags
    }

}

interface StateDefinition {
    state: string[];
    sentForSignatureFlag: boolean[];
    signingProcess: boolean[];
}

interface ContractStateMap {
    [key: string]: string;
}